import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./css/Landing.css";
import logo from "./Color logo with background copy.png";

// ─── Service card images ───────────────────────────────────────────────────────
// Swap the paths below to match your actual file locations
import imgWeb    from "./assets/Web.png";
import imgMobile from "./assets/Mobile.png";
import imgCloud  from "./assets/Cloud.png";
import imgICT    from "./assets/ICT.png";

function Nav2(){

    const [solid, setSolid] = useState(false);

  useEffect(() => {
    const fn = () => setSolid(window.scrollY > 20);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (

      <nav className={`nav${solid ? " solid" : ""}`}>
        <div className="nav-inner">
          <div className="nav-logo" style={{ padding: 0 }}>
            <img src={logo} alt="Seritonex" style={{ height: 36, width: "auto", display: "block" }} />
          </div>
        </div>
      </nav>
 );
}


// function Nav() {
//   const navigate = useNavigate();
//   const [solid, setSolid] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);

//   useEffect(() => {
//     const fn = () => setSolid(window.scrollY > 20);
//     window.addEventListener("scroll", fn, { passive: true });
//     return () => window.removeEventListener("scroll", fn);
//   }, []);

//   useEffect(() => {
//     document.body.style.overflow = menuOpen ? "hidden" : "";
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [menuOpen]);

  /*const links = [
    ["/", "Home"],

  ];

  const go = (path) => {
    setMenuOpen(false);
    navigate(path);
  };*/

//   return (
//     <>
//       <nav className={`nav${solid ? " solid" : ""}`}>
//         <div className="nav-inner">
//           <div className="nav-logo" onClick={() => go("/")} style={{ padding: 0 }}>
//             <img src={logo} alt="Seritonex" style={{ height: 36, width: "auto", display: "block" }} />
//           </div>

//           {/* Desktop links */}
//           <div className="nav-links">
//             {links.map(([path, label]) => (
//               <button
//                 key={path}
//                 className={`nav-link${window.location.pathname === path ? " active" : ""}`}
//                 onClick={() => go(path)}
//               >
//                 {label}
//               </button>
//             ))}
//             <button className="nav-cta" onClick={() => go("/shop")}>
//               Shop
//             </button>
//           </div>

//           {/* Hamburger — mobile only */}
//           <button
//             className={`nav-hamburger${menuOpen ? " nav-hamburger--open" : ""}`}
//             onClick={() => setMenuOpen((o) => !o)}
//             aria-label="Toggle menu"
//           >
//             <span />
//             <span />
//             <span />
//           </button>
//         </div>
//       </nav>

//       {/* Mobile drawer overlay */}
//       {menuOpen && (
//         <div className="mob-nav-overlay" onClick={() => setMenuOpen(false)}>
//           <div className="mob-nav-drawer" onClick={(e) => e.stopPropagation()}>
//             <div className="mob-nav-header">
//               <div
//                 className="nav-logo"
//                 style={{ cursor: "pointer" }}
//                 onClick={() => go("/")}
//               >
//                 <img src={logo} alt="Seritonex" style={{ height: 36, width: "auto", display: "block" }} />
//               </div>
//               <button
//                 className="mob-nav-close"
//                 onClick={() => setMenuOpen(false)}
//               >
//                 ✕
//               </button>
//             </div>
//             <div className="mob-nav-links">
//               {links.map(([path, label]) => (
//                 <button
//                   key={path}
//                   className={`mob-nav-link${window.location.pathname === path ? " mob-nav-link--active" : ""}`}
//                   onClick={() => go(path)}
//                 >
//                   {label}
//                 </button>
//               ))}
//               <button className="mob-nav-cta" onClick={() => go("/shop")}>
//                 Shop
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

function GlitchText({ children, className }) {
  return (
    <span className={`glitch-wrap ${className || ""}`} data-text={children}>
      {children}
    </span>
  );
}

function Typewriter({ words, speed = 80, pause = 1800 }) {
  const [displayed, setDisplayed] = useState("");
  const [wordIdx, setWordIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const current = words[wordIdx];
    let timeout;
    if (!deleting) {
      if (charIdx < current.length) {
        timeout = setTimeout(() => setCharIdx((i) => i + 1), speed);
      } else {
        timeout = setTimeout(() => setDeleting(true), pause);
      }
    } else {
      if (charIdx > 0) {
        timeout = setTimeout(() => setCharIdx((i) => i - 1), speed / 2);
      } else {
        setDeleting(false);
        setWordIdx((i) => (i + 1) % words.length);
      }
    }
    setDisplayed(current.slice(0, charIdx));
    return () => clearTimeout(timeout);
  }, [charIdx, deleting, wordIdx, words, speed, pause]);

  return (
    <span className="typewriter">
      {displayed}
      <span className="typewriter-cursor">|</span>
    </span>
  );
}

function Counter({ target, suffix, duration = 1800 }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const isFloat = target.includes && target.includes(".");
          const num = parseFloat(target);
          const steps = 60;
          const inc = num / steps;
          let cur = 0;
          const timer = setInterval(() => {
            cur += inc;
            if (cur >= num) {
              cur = num;
              clearInterval(timer);
            }
            setCount(isFloat ? cur.toFixed(1) : Math.floor(cur));
          }, duration / steps);
        }
      },
      { threshold: 0.3 },
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target, duration]);

  return (
    <span ref={ref} className="counter-val">
      {isNaN(target) ? target : count}
      {suffix}
    </span>
  );
}

function Ticker() {
  const items = [
    "Web Development",
    "Mobile Applications",
    "Cloud Infrastructure",
    "UI/UX Design",
    "DevOps Solutions",
    "API Architecture",
    "System Integration",
    "Digital Strategy",
  ];
  const doubled = [...items, ...items];
  return (
    <div className="ticker-wrap">
      <div className="ticker-track">
        {doubled.map((s, i) => (
          <div key={i} className="ticker-item">
            <div className="dot" />
            {s}
          </div>
        ))}
      </div>
    </div>
  );
}

function Arrow() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M2 7h10M7 2l5 5-5 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ParticleField() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let raf;
    let W = (canvas.width = canvas.offsetWidth);
    let H = (canvas.height = canvas.offsetHeight);

    const particles = Array.from({ length: 55 }, () => ({
      x: Math.random() * W,
      y: Math.random() * H,
      vx: (Math.random() - 0.5) * 0.35,
      vy: (Math.random() - 0.5) * 0.35,
      r: Math.random() * 1.5 + 0.4,
      alpha: Math.random() * 0.5 + 0.15,
    }));

    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0) p.x = W;
        if (p.x > W) p.x = 0;
        if (p.y < 0) p.y = H;
        if (p.y > H) p.y = 0;

        particles.forEach((q) => {
          const dx = p.x - q.x,
            dy = p.y - q.y;
          const d = Math.sqrt(dx * dx + dy * dy);
          if (d < 120) {
            ctx.beginPath();
            ctx.strokeStyle = `rgba(184,255,87,${0.06 * (1 - d / 120)})`;
            ctx.lineWidth = 0.5;
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(q.x, q.y);
            ctx.stroke();
          }
        });

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(184,255,87,${p.alpha})`;
        ctx.fill();
      });
      raf = requestAnimationFrame(draw);
    };

    draw();
    const resize = () => {
      W = canvas.width = canvas.offsetWidth;
      H = canvas.height = canvas.offsetHeight;
    };
    window.addEventListener("resize", resize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={canvasRef} className="particle-canvas" />;
}

function ScrambleText({ text, trigger, delay = 0 }) {
  const [displayed, setDisplayed] = useState(text);
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%";
  const rafRef = useRef(null);

  useEffect(() => {
    if (!trigger) return;
    let iteration = 0;
    const total = text.length * 3;
    const step = () => {
      setDisplayed(
        text
          .split("")
          .map((char, idx) => {
            if (char === " " || char === "\n") return char;
            if (idx < iteration / 3) return char;
            return chars[Math.floor(Math.random() * chars.length)];
          })
          .join(""),
      );
      iteration++;
      if (iteration <= total) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        setDisplayed(text);
      }
    };
    const t = setTimeout(() => {
      rafRef.current = requestAnimationFrame(step);
    }, delay);
    return () => {
      clearTimeout(t);
      cancelAnimationFrame(rafRef.current);
    };
  }, [trigger]);

  return <>{displayed}</>;
}

export default function MainHome() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [statsVisible, setStatsVisible] = useState(false);
  const statsRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const t = setTimeout(() => setReady(true), 100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const el = statsRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) setStatsVisible(true);
      },
      { threshold: 0.2 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const stats = [
    { n: "19", suffix: "+", label: "Projects Delivered" },
    { n: "99.9", suffix: "%", label: "Uptime SLA" },
    { n: "5", suffix: "+", label: "Years Experience" },
    { n: "24/7", suffix: "", label: "Support Coverage" },
  ];

  const whyStats = [
    { n: "19", suffix: "+", l1: "Projects", l2: "Delivered" },
    { n: "99.9", suffix: "%", l1: "Uptime", l2: "SLA" },
    { n: "5", suffix: "+", l1: "Years of", l2: "Experience" },
    { n: "24/7", suffix: "", l1: "Support", l2: "Coverage" },
  ];

  // ─── Service cards ─────────────────────────────────────────────────────────
  // To add/change an image: import it at the top of the file, then set `img`
  // to that imported variable. Never use a raw string path here.
  const services = [
    {
      num: "01",
      img: imgWeb,
      title: "WEB DEVELOPMENT",
      desc: "Robust, scalable web applications tailored for your business goals, built with battle-tested frameworks.",
    },
    {
      num: "02",
      img: imgMobile,
      title: "MOBILE APPS",
      desc: "Native and cross-platform apps that deliver seamless experiences on iOS and Android.",
    },
    {
      num: "03",
      img: imgCloud,
      title: "CLOUD INTEGRATION",
      desc: "Secure, auto-scaling cloud infrastructure that grows with your business without missing a beat.",
    },
    {
      num: "04",
      img: imgICT,
      title: "ICT SOLUTIONS",
      desc: "End-to-end ICT consulting, network infrastructure, hardware procurement, and managed IT services to keep your business connected and running at full capacity.",
    },
  ];
  // ───────────────────────────────────────────────────────────────────────────

  return (
    <div className="landing-root">
      <Nav2 />

      <div className="page">
        <section className="hero">
          <ParticleField />
          <div className="hero-grid" />
          <div className="hero-light" />
          <div className="hero-scan" />
          <div className="hero-noise" />

          <div className="hero-content">
            <div className="hero-left">
              <div className={`overline hero-overline ${ready ? "anim-in" : ""}`}>
                Enterprise IT Solutions
              </div>

              <h1 className="hero-title">
                <span className={`title-line title-line--1 ${ready ? "anim-in" : ""}`}>
                  WE BUILD
                </span>
                <span className={`title-line title-line--2 ${ready ? "anim-in" : ""}`}>
                  <em>
                    <ScrambleText text="SYSTEMS" trigger={ready} delay={400} />
                  </em>
                </span>
                <div className={`title-line title-line--3 volt volt-animated ${ready ? "anim-in" : ""}`}>
                  THAT{""}
                <span className="volt volt-animated">
                  <GlitchText>SCALE</GlitchText>
                </span>
              </div>
              </h1>

              <div className={`hero-typewriter-row ${ready ? "anim-in" : ""}`}>
                <span className="hero-tw-prefix">// </span>
                <Typewriter
                  words={[
                    "custom software",
                    "cloud infrastructure",
                    "digital experiences",
                    "scalable systems",
                  ]}
                />
              </div>

              <div className={`hero-meta ${ready ? "anim-in" : ""}`}>
                <p className="hero-desc">
                  Custom <strong>software</strong>,{" "}
                  <strong>cloud infrastructure</strong> and{" "}
                  <strong>digital experiences</strong> engineered to perform
                  at any scale.
                </p>
                <button
                  className="hero-cta hero-cta--animated"
                  onClick={scrollToContact}
                >
                  Start a Project <Arrow />
                  <span className="cta-ripple" />
                </button>
              </div>
            </div>

            <div className="hero-right">
              <div className="hero-orbit hero-orbit--outer" />
              <div className="hero-orbit hero-orbit--inner" />
              <div className="hero-logo-box">
                <img
                  src="/Color%20logo%20-%20no%20background.png"
                  alt="Seritonex"
                />
                <div className="logo-scan-line" />
              </div>
              <div className="hero-badge hero-badge--tl">
                <span className="badge-dot" />
                <span className="badge-label">LIVE SYSTEMS</span>
              </div>
              <div className="hero-badge hero-badge--br">
                <span className="badge-num">99.9%</span>
                <span className="badge-sub">uptime</span>
              </div>
            </div>
          </div>

          <div className="hero-stats" ref={statsRef}>
            {stats.map(({ n, suffix, label }, i) => (
              <div
                key={i}
                className={`stat-item ${statsVisible ? "stat-item--visible" : ""}`}
                style={{ animationDelay: `${i * 0.1}s` }}
              >
                <div className="stat-n">
                  {statsVisible ? (
                    <Counter target={n} suffix={suffix} />
                  ) : (
                    <span>{n}{suffix}</span>
                  )}
                </div>
                <div className="stat-l">{label}</div>
                <div className="stat-bar" />
              </div>
            ))}
          </div>
        </section>

        <Ticker />

        <section className="services-section">
          <div className="services-header">
            <div>
              <div className="overline">What We Build</div>
              <h2 className="services-title">
                OUR
                <br />
                <em>SERVICES</em>
              </h2>
            </div>
            <p className="services-desc">
              From pixel-perfect interfaces <br /> to resilient cloud systems
              <br /> — we cover the full stack of <br />
              modern software delivery.
            </p>
          </div>

          <div className="services-rail">
            {services.map((s, i) => (
              <div key={i} className="svc-card">
                <div className="svc-img-wrap">
                  <img src={s.img} alt={s.title} className="svc-img" />
                </div>
                <div className="svc-body">
                  <div className="svc-num">{s.num}</div>
                  <div className="svc-title">{s.title}</div>
                  <p className="svc-desc">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="why-section">
          <div className="why-inner">
            <div className="why-left">
              <div className="overline">Why Seritonex</div>
              <h2 className="why-title">
                BUILT
                <br />
                <span>DIFFERENT.</span>
                <br />
                BUILT TO WIN.
              </h2>
              <p className="why-body">
                We combine agile methodology, deep technical expertise, and a
                relentless focus on outcomes to deliver software that actually
                moves the needle.
              </p>
              <ul className="why-list">
                {[
                  "Proven track record across 19+ projects",
                  "Agile delivery — on time, on budget",
                  "Dedicated expert team with deep domain knowledge",
                  "24/7 support with guaranteed response SLAs",
                ].map((w) => (
                  <li key={w} className="why-item">
                    <span className="why-check">✓</span>
                    {w}
                  </li>
                ))}
              </ul>
            </div>

            <div className="why-right">
              <div className="why-grid">
                {whyStats.map(({ n, suffix, l1, l2 }, i) => (
                  <div key={i} className="why-stat">
                    <div className="why-stat-n">
                      {n}
                      <span className="volt-accent">{suffix}</span>
                    </div>
                    <div className="why-stat-l">
                      {l1}
                      <br />
                      {l2}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <footer className="footer-contact" ref={contactRef}>
          <div className="footer-contact-strip">
            <div className="footer-contact-card">
              <div className="footer-contact-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.07 2.18 2 2 0 012.05 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14.92z" />
                </svg>
              </div>
              <div>
                <h4>Call Us</h4>
                <a href="tel:+27176204329">+27 17 620 4320</a>
                <span>Mon – Thu&nbsp;&nbsp;08:00 – 17:00</span>
                <span>Fri&nbsp;&nbsp;08:00 – 14:00</span>
              </div>
            </div>

            <div className="footer-contact-card">
              <div className="footer-contact-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <div>
                <h4>Email Us</h4>
                <a href="mailto:info@seritonex.com">info@seritonex.com</a>
                <span>Response within 24 – 48 hours</span>
              </div>
            </div>

            <div className="footer-contact-card">
              <div className="footer-contact-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <div>
                <h4>Visit Us</h4>
                <span className="footer-contact-detail">21 Danie Theron St</span>
                <span>Secunda, Mpumalanga</span>
              </div>
            </div>

            <div className="footer-contact-card">
              <div className="footer-contact-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </div>
              <div>
                <h4>Business Hours</h4>
                <span className="footer-contact-detail">Mon – Thu: 08:00 – 17:00</span>
                <span className="footer-contact-detail">Fri: 08:00 – 14:00</span>
              </div>
            </div>
          </div>

          <div className="footer-map-wrap">
            <div className="footer-map-inner">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d968.180886419074!2d29.186464741455445!3d-26.49962778788713!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1eeb124d366694a7%3A0x153440fa8b70a78e!2s21%20Danie%20Theron%20St%2C%20Secunda%2C%202302%2C%20South%20Africa!5e1!3m2!1sen!2sus!4v1772777975701!5m2!1sen!2sus"
                style={{ border: 0, width: "100%", height: "100%" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Seritonex location"
              />
            </div>
            <a
              href="https://www.google.com/maps/place/21+Danie+Theron+St,+Secunda,+2302,+South+Africa"
              target="_blank"
              rel="noreferrer"
              className="footer-map-link"
            >
              Open in Google Maps
              <svg width="12" height="12" viewBox="0 0 14 14" fill="none" style={{ marginLeft: 6 }}>
                <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </div>

          <div className="footer-bottom">
            <div className="footer-bottom-logo">
              <img src={logo} alt="Seritonex" style={{ height: 36, width: "auto", display: "block" }} />
            </div>
            
            <div className="footer-copy">
              © {new Date().getFullYear()} SERITONEX — ALL RIGHTS RESERVED
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}